import Api from '@/services/Api'

export default {

  get (params) {
    return Api().get('websites/' + params.id + '/products')
  }

}



// WEBPACK FOOTER //
// ./src/services/WebsiteProductsService.js